import Vue from 'vue';
import BasicBlock from './BasicBlock';
import { SmartSuggestV4 } from '../../../../declarations/request';
import { InteractionBlockTypes } from '../../services/HandleInteractionService';

export enum LandingPageMatchTypes {
    full = 'full',
    prefix = 'prefix',
}

export default Vue.component('smart-suggest-landingpage', {
    template: `
    <smart-suggest-block class="fl-as-landingpage" :icon="assets.iconFilter" :name="config.blocks.landingpage"
                         v-if="config.blocks.landingpage && landingpage">
      <ul class="fl-as-smart-suggest-list-container fl-as-landingpage-list-container">
        <li class="fl-as-smart-suggest-list-option fl-as-landingpage-list-option"
            v-html="landingpageName"
            @click="selectValue(landingpage)"
        />
      </ul>
    </smart-suggest-block>
  `,
    inject: ['config', 'assets', 'HandleInteractionService', 'HandleShopInteractionService', 'utils'],
    props: { landingpage: Object },
    components: {
        basic: BasicBlock,
    },
    methods: {
        selectValue(landingpage: SmartSuggestV4.Landingpage): void {
            void this.HandleInteractionService.byBlock(InteractionBlockTypes.landingpage)
                .withUrl(landingpage.name, landingpage.url)
                .trackAndSubmit();
        },
    },
    computed: {
        landingpageName(): string {
            return this.config.assistedSuggest.config.highlightMatchesInSuggestions
                ? this.utils.generateHighlightedHtml(this.landingpage.name, this.HandleShopInteractionService.getActiveInputValue())
                : this.utils.escapeUserProvidedText(this.landingpage.name);
        },
    },
});
